/**
 * @summary     app.ajax.js
 * @description App JS Local Ajax Controller
 * @version     1.4
 	> 1.0 Initial version
  		- 06/01/2014 SG
	> 1.1 Added local caching mechanism - this has a depedency on app.localCache
		- 01/19/2016 SG
	> 1.2 Fixed bugs with success methods not using scope when cached
		- 03/15/2016 SG
	> 1.3 Added better support for JSON post requests
		- 07/19/2016 SG
	> 1.4 Added settings and other attributes to cached version retrieval
		- 08/01/2016 SG
	> 1.5 Added responseType as a parameter for predefined parsing
		- 08/11/2016 SG
 * @file        app.ajax.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 *
 * This source file is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 *
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature("ajax",function(){
	"use strict";

	var httpHandler,
		// Defaults for each request
		defaults = {
			target : null,
			method : "POST",
			syncr : true,
			contentType : "application/x-www-form-urlencoded",
			url : "?page=ajax",
			responseType : "text",
			args : {},
			timeout : 90000,
			/*
				NOTE:
					Added cacheLife to allow some requests to be cached locally.  If the value is greater than zero it will use the browser's local cache to store the data for quicker response.
					cacheKeys is an array of unique variables to use from the args object to ensure we cache very specific requests and not just the URL
					- sg 01/19/2016
			*/
			cacheLife : 0,
			cacheKeys : [],
			cacheScope : "session",
			// Default success handler just posts response to target's innerHTML (if specified)
			success : function(){
				if(this.settings.target !== null){
					this.settings.target.innerHTML = this.responseText;
				}

				return this;
			},
			error : function(){
				console.log("AJAX Error: {settings.url} {responseText}".assign(this));

				return this;
			},
			stateChange : function(a){},
			status : {},
			state : {},
			onTimeout : function(){
				this.abort();
			}
		},
		connections = 0,
		request;

	// Setup global handler for HTTP state changes
	// Runs within each instances (new XMLHttpRequest) scope
	function httpHandler(){
		/* Completed state */
		if(this.readyState === 4) {
			this.requestEnd = new Date().getTime().val();
			this.responseJson = null;

			// If a timeout was set, kill it now
			if(this.requestTimer){
				this.requestTimer.cancel();
			}

			if(this.status === 200 || this.status === 304 || this.status === 0){
				var err = false;

				/*
					NOTE:
						If we're expecting JSON as the response type then make sure that's what we're getting
				*/
				if((this.settings.responseType || "").toLowerCase() === "json"){
					try {
						this.responseJson = JSON.parse(this.responseText.trim());
					}
					catch(e){
						err = true;
						this.settings.error.apply(this.scope?this.scope:this,[this]);
					}
				}

				if(!err){
					// If a cacheLife is set, then let's cache the request and its cache date
					if(this.settings.cacheLife.val() > 0 && this.settings.cacheKey && app.localCache){
						app.localCache.set(this.settings.cacheKey,(this.settings.responseType || "").toLowerCase() === "json"?this.responseJson:this.responseText,this.settings.cacheScope);
						app.localCache.set(this.settings.cacheKey.append(".dts"),new Date().getTime(),this.settings.cacheScope);
					}
					this.settings.success.apply(this.scope?this.scope:this,[this]);
				}
			}
			else{
				this.settings.error.apply(this.scope?this.scope:this,[this]);
			}

			/* Custom status code handlers */
			if(this.settings.status[this.status]){
				this.settings.status[this.status].apply(this);
			}

			/* Down the connections count */
			--connections;
		}

		/* Allow customization for each change in state */
		if(this.settings.state[this.readyState]){
			this.settings.state[this.readyState].apply(this);
		}
	};

	function request(settings){
		// Copy defaults into settings for this request, setup new request and start timer
		var settings = app.utils.copy(defaults,settings || {},false,false),
			http = new XMLHttpRequest(),
			startTime = new Date().getTime().val(),
			cacheKey = "app.ajax.".append(settings.url);

		// Compile a unique cache key
		settings.cacheKeys.forEach(
			function(key){
				cacheKey = cacheKey.append("-").append(settings.args[key]);
			}
		);

		// Put it on the settings since it gets put on the http object
		settings.cacheKey = cacheKey;

		/*
			NOTE:
				Begin logic for caching mechanism
				- sg 01/19/2016
		*/
		if(settings.cacheLife.val() > 0 && app.localCache){
			var cache = app.localCache.get(cacheKey,settings.cacheScope),
				cacheJson = null,
				cacheDts = app.localCache.get(cacheKey.append(".dts"),settings.cacheScope);

			// If cache is found and is still valid, then just pull it back
			if(cache !== null && cacheDts !== null && cacheDts.val(settings.cacheLife.val()) > new Date().getTime()){
				/*
					NOTE:
						If we're expecting JSON, make sure the cache is right
				*/
				if((settings.responseType || "").toLowerCase() === "json"){
					try {
						cacheJson = typeof cache === "string"?JSON.parse(cache.trim()):cache;
					}
					catch(e){}
				}

				http = {
					readyState : 4,
					status : 304,
					// The caching utility converts JSON to objects on get, but we need it as text so response parsing doesn't break, except if we're expecting JSON
					responseText : typeof cache !== "string"?JSON.stringify(cache):cache,
					responseJson : cacheJson,
					cacheLife : 0,
					settings : settings,
					scope : settings.scope || settings.args.scope || false
				};

				settings.success.apply(settings.scope || settings.args.scope || http,[http]);

				return http;
			}
		}

		// Timer
		http.requestBegin = startTime;

		// Open request and only allow GET for certain file types
		http.open(["js","json","html","tmpl"].indexOf(settings.url.split(".")[1]) !== -1?"GET":settings.method,
				settings.url + ((settings.url.right(3) === ".js")?("?dts=" + new Date().getTime().toString()):""),
				settings.syncr);
		// Content type, almost always coming from the default
		http.setRequestHeader("Content-type", settings.contentType);
		// Let the settings passed in be availabe on the HTTP request
		http.settings = settings;
		// Change state handler
		http.onreadystatechange = httpHandler;
		// Allow the event handlers to be run in a certain scope/context - default to "false"
		// because we'll just set the context to each http instance
		http.scope = settings.scope || settings.args.scope || false;
		// Send for scope/url string
		http.send(
			typeof settings.args === "string"?settings.args:(
				settings.contentType === "application/json"?JSON.stringify(settings.args):JSON.toURL(settings.args)
			)
		);

		// Just return the http object which has responseText attached if running synchronously
		if(!settings.syncr){
			return http;
		}
		else{
			// Up the request count
			++connections;

			// Allow for a specific timeout to be set (in ms) per request - zero means no timeout (default)
			settings.timeout = Math.abs(settings.timeout.val());
			if(settings.timeout > 0){
				http.requestTimer = (function(){
					if(new Date().getTime().val() - startTime > this.settings.timeout){
						// Cancel tracking timer
						this.requestTimer.cancel();
						// Run the onTimeout method (which defaults to aborting the http request)
						this.settings.onTimeout.apply(this);
					}
				}).Every(50,[],http);
			}
		}

		return http;
	};

    function requestAsync(
      args,
      { responseType = 'json', cacheLife = 0, timeout = 0, url = '/', scope, contentType } = {}
    ) {
      return new Promise((resolve, reject) => {
        request({
          responseType,
          success: (res) => resolve(responseType === 'json' ? res.responseJson : res.responseText),
          error: reject,
          args,
          cacheLife,
          timeout,
          scope,
          contentType,
          url,
        });
      });
    }

    this.request = request;
    this.requestAsync = requestAsync;

	return this;
});
